import {tap, forEach, head, values, props, path, groupBy, map, prop, pipe, zip, zipObj, merge, reject} from 'ramda'
import moment from 'moment-timezone'
import paystubTemplate from '../../profile-webview/paystub/paystub.html'
import paystubController from '../../profile-webview/paystub/paystub.ctrl.js'
import startOfWeek from 'date-fns/start_of_week'
import directDepositController from '../../profile-webview/direct-deposit/direct-deposit.ctrl'
import directDepositTemplate from '../../profile-webview/direct-deposit/direct-deposit.html'
import confirmationCodeForm from '../../profile-webview/direct-deposit/confirmationCodeForm.html'
import ConfirmationCodeFormController from '../../profile-webview/direct-deposit/confirmationCodeForm.ctrl'
import errorHandler from '../../../shared/errorHandler'

class PayrollController {
    /**
     * @type {PayrollClient}
     */
    payrollClient;
    /* @ngInject */
    constructor (UsersService, user, Payroll, Users, Shifts, payroll, segment, $state, $mdToast, $scope, $mdDialog, $stateParams, $window, Paystub, PayrollService, PayrollClient, Auth, Message) {
        // let reviewType
        this.user = user
        this.UsersService = UsersService
        this.Message = Message
        this.bankAccounts = []
        if (this.user.type !== 0) {
            // if not bluecrew worker, get the users profile
            Users.getProfile($stateParams.userId)
                .then(results => {
                    this.worker = results
                })
        } else {
            this.worker = user
            this.getBankAccounts(this.worker.internalId)
                .then(bankAccounts => {
                    this.bankAccounts = bankAccounts
                })
        }
        this.Auth = Auth
        this.payrollClient = PayrollClient
        this.Users = Users
        this.Payroll = Payroll
        this.PayrollService = PayrollService
        this.Shifts = Shifts
        this.week = $stateParams.week
        this.$state = $state
        this.$mdDialog = $mdDialog
        this.payroll = payroll
        this.$stateParams = $stateParams
        this.$window = $window
        this.paylocityCompanyId = 125190
        this.approvedODPEarnings = 0
        this.currTime = new Date()
        this.currentPayrollWeekStartDate = moment(startOfWeek(this.currTime, {weekStartsOn: 1})).format("MM/DD")
        this.segment = segment
        this.defaultLunchDuration = 30
        this.maxTimestampDistance = 400
        this.showPaymentsTab = false

        if (this.payroll.payroll.companies) {
            this.jobs = payroll.jobs
            this.companies = payroll.companies
            this.merged = []
            this.date = []
            let companyId
            const sortDates = pipe(
                tap((company) => { companyId = company.id }),
                prop('dates'),
                map((x) => {
                    x.jobs.forEach(job => {
                        this.date.push(x.date)
                        job.companyId = companyId
                        job.date = x.date
                        job.start = new Date(prop('start', job))
                        job.end = new Date(prop('end', job))
                        var jobData = props(['id', 'start', 'end', 'shift', 'shiftEnded', 'companyId', 'date'], job)
                        var users = prop('users', job)
                        users.forEach(user => {
                            var jobObj = zipObj(['jobId', 'start', 'end', 'shift', 'shiftEnded', 'companyId', 'date'], jobData)
                            this.merged.push(merge(user, jobObj))
                        })
                    })
                })
            )
            pipe(
                path(['payroll', 'companies']),
                forEach(sortDates)
            )(payroll)
            this.dateStamps = values(groupBy(head, zip(this.date, this.merged)))
            this.users = payroll.users
        }
        this.$mdToast = $mdToast
        this.$scope = $scope
        this.selectAllStamps = false
        this.startDateOfWeek = moment((this.$stateParams.week * 6.048e8) + 3.744e8).toDate()

        this.selectedTimeSegments
        this.Paystub = Paystub

        this.isPlaidEnabled = false
        this.validatePaymentsTabFlag()
    }

    getPaystubData () {
        this.Payroll.getUserPaystub({ userId: this.worker.external_id })
            .then(result => {
                this.paystubs = result
                if (this.worker.checkr_id) {
                    this.Users.getCheckrData(this.worker.checkr_id)
                        .then(result => {
                            this.checkrData = result
                        }).finally(() => {
                        this.paystubsLoaded = true
                    })
                } else {
                    this.paystubsLoaded = true
                }
            })
    }

    showPaystub (paystub) {
        const parentEl = document.body
        this.$mdDialog.show({
            parent: parentEl,
            fullscreen: true,
            multiple: true,
            locals: {
                paystub,
                checkrData: this.checkrData || null,
                user: this.worker,
                inModal: true
            },
            template: paystubTemplate,
            controller: paystubController,
            controllerAs: 'w'
        })
    }

    openPaylocity() {
        this.segment.track('ODP_Button_Launch', {
            userId: this.worker.external_id,
            approvedEarnings: this.approvedODPEarnings
        })
        this.$window.open('https://access.paylocity.com?companyId=125190', '_blank');
    }

    // This function currently retrieves the amount of approved earnings (wage * total hours) for the current payroll week
    getApprovedODPEarnings () {
        this.Payroll.getUserPaystub({ userId: this.externalUserId })
            .then(result => {
                this.paystubs = result
            })
        this.approvedODPEarnings = "--"
        // calculate week num for get user payroll week number
        let weekNum = Math.floor((this.currTime - 3.744e8) / 6.048e8)
        this.Payroll.getUserPayroll({ week: weekNum, userId: this.worker.external_id})
            .then((payroll) => {
                this.approvedODPEarnings = 0
                if (payroll.companies) {
                    let jobs = payroll.jobs
                    let companyId
                    let merged = [];
                    let date = [];
                    // uses same sorting/merging logic found https://github.com/Bluecrew/web-angular/blob/9ced105257fb802656a49d93317538b89d49c312/src/client/public/js/ng-bluecrew/components/payroll/user/userTimestamps.controller.js#L73
                    const sortDates = pipe(
                        tap((company) => { companyId = company.id }),
                        prop('dates'),
                        map((x) => {
                            date.push(x.date)
                            x.jobs.forEach(job => {
                                job.companyId = companyId
                                job.date = x.date
                                job.start = new Date(prop('start', job))
                                job.end = new Date(prop('end', job))
                                var jobData = props(['id', 'start', 'end', 'shift', 'shiftEnded', 'companyId', 'date'], job)
                                var users = prop('users', job)
                                users.forEach(user => {
                                    var jobObj = zipObj(['jobId', 'start', 'end', 'shift', 'shiftEnded', 'companyId', 'date'], jobData)
                                    merged.push(merge(user, jobObj))
                                })
                            })
                        })
                    )
                    pipe(
                        path(['payroll', 'companies']),
                        forEach(sortDates)
                    )(payroll)

                    let dateStamps = values(groupBy(head, zip(date, merged)))
                    dateStamps.forEach(dateStamp => {
                        dateStamp.forEach(shift => {
                            // aggregate approved earnings for shifts
                            if (shift[1].hoursStatus === "APPROVED") {
                                this.approvedODPEarnings += this.calculateApprovedHours (shift[1].hoursStart, shift[1].hoursEnd, shift[1].lunchDuration) * jobs[shift[1].jobId].wage
                            }
                        })
                    })
                    // round to nearest hundreth
                    this.approvedODPEarnings = Math.round(100*(this.approvedODPEarnings))/100;
                }
                this.segment.track('ODP_Tab_Click', {
                    userId: this.worker.external_id,
                    approvedEarnings: this.approvedODPEarnings
                })
            })
            .catch((err) => {
                console.log(err)
                this.$mdDialog.show(
                    this.$mdDialog.alert()
                        .parent(angular.element(document.querySelector('body')))
                        .clickOutsideToClose(true)
                        .title('Server Error')
                        .textContent('There was an error fetching payroll data. Please try again later.')
                        .ariaLabel('Server Error')
                        .ok('OK')
                ).then(this.$state.go('login'))
            })
    }

    updateWeek (day) {
        this.$stateParams.week = Math.floor((day - 3.744e5) / 6.048e5 / 1000)
        this.startDateOfWeek = day
        this.$state.go('app.pay', {week: this.$stateParams.week, userId: this.$stateParams.userId}, {reload: true})
    }

    approveShift (jobId, startTime, endTime, shift, lunch) {
        let shiftData = {
            jobId: jobId,
            lunchDuration: lunch,
            shiftStart: startTime,
            shiftEnd: endTime,
            shift: shift,
            userId: this.$stateParams.userId
        }
        this.Payroll.approveShift(shiftData)
            .then(result => {
                this.$mdToast.showSimple(`Submitted Hours for ${moment(startTime).format('ddd MMM Do')}`)
            }, () => { this.$mdToast.showSimple('Error Submitting Hours') })
    }

    calculateApprovedHours (start, end, lunchDuration) {
        const lunchDurationInMinutes = lunchDuration * 60
        return this.Shifts.calcTotalHours(start, end, lunchDurationInMinutes)
    }

    calcTotalHours (timeIn, timeOut, editIn, editOut, lunch) {
        const end = (timeOut && timeOut.length) ? timeOut[0].time : editOut
        const start = (timeIn && timeIn.length) ? timeIn[0].time : editIn
        const lunchDuration = (lunch !== null) ? lunch : 0

        let hours = this.Shifts.calcTotalHours(start, end, lunchDuration)
        hours = (lunch === null && hours > 5) ? this.Shifts.calcTotalHours(start, end, this.defaultLunchDuration) : hours
        return hours
    }

    onlySundayPredicate (date) {
        var day = date.getDay()
        return day === 1
    }

    reportMissing (ev, shift) {
        const message = 'Hours Edit Request\n' + shift.date + ' · ' + this.companies[shift.companyId].name + ' · ' + this.jobs[shift.jobId].title + '\nTime clocked in:\n' + 'Time clocked out:\n' + 'Reason for not clocking in:'
        
        this.Message.getIntercomToken()
            .then(function(response) {
                const intercomData = Object.assign({}, this.user.intercom, {
                    user_id: this.user.id,
                    email: this.user.username,
                    intercom_user_jwt: response.jwt
                })
                this.$window.Intercom('update', intercomData)
                this.$window.Intercom('showNewMessage', message)
            }.bind(this))
            .catch(function(error) {
                errorHandler(error)
                // Fallback: show message without JWT (will fail but won't break UI)
                this.$window.Intercom('showNewMessage', message)
            }.bind(this))
    }

    /*
    This is copied over from src/client/public/js/ng-bluecrew/components/profile-webview/controller.js in order to support the ionic
    profile migration.
    */
    initializePlaid () {
        this.isPlaidEnabled = this.Auth.splitClient.getTreatment('plaid-enabled', {internal_id: this.user.internalId}) === 'on';

        if (!this.isPlaidEnabled) {
            return;
        }

        this.payrollClient.createPlaidLinkToken().then((response) => {
            const linkConfig = {
                token: response.data.link_token,
                receivedRedirectUrl: this.$window.location.href,
                onSuccess: (public_token, metadata) => {
                    if (metadata.accounts.length === 0) {
                        return this.$mdToast.showSimple('You didn\'t select an account')
                    }
                    const account = metadata.accounts[0];
                    // For the future if we want to allow multiple bank account deposits
                    // metadata.accounts.forEach((account) => {
                    //   account.calculation_method = 0
                    //   account.percentage = null
                    //   account.amount = null
                    //   this.selectedAccounts.push(account)
                    // })
                    // if (metadata.accounts.length === 1) {
                    //   this.plaidSaveAccount(metadata)
                    // } else {
                    //   // For the future if we want to mallow multiple bank account deposits
                    //   this.showAccountBreakout = true
                    // }
                    account.calculation_method = 0
                    account.percentage = null
                    account.amount = null

                    const plaidPayload = {
                        public_token,
                        accounts: metadata.accounts,
                        institution: metadata.institution
                    }

                    this.attemptSavePlaidAccount(plaidPayload)
                },
                onExit: async (err, metadata) => {
                    // The user exited the Link flow with an INVALID_LINK_TOKEN error.
                    // This can happen if the token expires or the user has attempted
                    // too many invalid logins.
                    if (err != null && err.error_code === 'INVALID_LINK_TOKEN') {
                        this.plaidLink.destroy();
                        this.plaidLink = this.$window.Plaid.create({
                            ...linkConfig,
                            // Fetch a new link_token because the old one was invalidated.
                            token: await this.payrollClient.createPlaidLinkToken(),
                        });
                    }
                    // metadata contains the most recent API request ID and the
                    // Link session ID. Storing this information is helpful
                    // for support.
                },
            }

            this.plaidLink = this.$window.Plaid.create(linkConfig)
        })
    }

    openPlaid () {
        if (!this.isPlaidEnabled) {
            return this.showDirectDepositDialog()
        }
        this.plaidLink.open()
    }

    async attemptSavePlaidAccount (metadata) {
        try {
            await this.PayrollService.sendConfirmationCode(this.user.internalId)
        } catch (e) {
            console.error(`An error occured while attempting to send a confirmation code for user with id ${this.user.internalId}`)
            this.$mdDialog.hide()
            this.$mdToast.showSimple('Failed to send confirmation code. Please try again')
            return
        }
        this.openConfirmationCodeModalForSavingPlaid(metadata)
    }

    async plaidSaveAccount (metadata, confirmationCode) {
        await this.PayrollService.plaidSaveAccount(this.user.internalId, metadata, confirmationCode)
        this.$mdDialog.hide()
        this.worker.hasDirectDeposit = true
        this.$mdToast.showSimple('Direct deposit info saved')
        this.getBankAccounts(this.user.internalId).then(bankAccounts => {
            this.bankAccounts = bankAccounts
        })
    }

    showDirectDepositDialog () {
        const parentEl = document.body
        this.$mdDialog.show({
            parent: parentEl,
            template: directDepositTemplate,
            locals: {
                userId: this.user.internalId,
                onDirectDepositSaveSuccess: () => {
                    this.getBankAccounts(this.user.internalId)
                        .then(bankAccounts => this.bankAccounts = bankAccounts);
                }
            },
            controller: directDepositController,
            controllerAs: 'ctrl'
        })
    }

    openConfirmationCodeModalForSavingPlaid (metadata) {
        this.$mdDialog.show({
            parent: document.body,
            template: confirmationCodeForm,
            controller: ConfirmationCodeFormController,
            controllerAs: 'l',
            locals: {
                handleSubmitCode: async (confirmationCode) =>
                    await this.plaidSaveAccount(metadata, confirmationCode)
            }
        })
    }

    activateBankAccount (bankAccountId) {
        this.UsersService.activateBankAccount(this.user.internalId, bankAccountId)
            .then(() => {
                this.bankAccounts = this.bankAccounts.map(a => {
                    a.active = a.id === bankAccountId
                    return a
                })
                this.$mdToast.showSimple('Bank account activated.')
            })
            .catch(() => {
                this.$mdToast.showSimple('Unable to activate bank account.')
            })
    }

    deleteBankAccount (bankAccountId, accountNumber) {
        this.$mdDialog.show(
            this.$mdDialog.confirm()
                .title(`Are you sure you want to disconnect your bank account ending in ${accountNumber}? Note: Please give 24 hours for these changes to reflect in Paylocity`)
                .ariaLabel('Confirm bank account deletion')
                .ok('OK')
                .cancel('Cancel')
        )
            .then(() => {
                this.UsersService.deleteBankAccount(this.user.internalId, bankAccountId)
                    .then(() => {
                        this.bankAccounts = reject(a => a.id === bankAccountId, this.bankAccounts)
                        this.$mdToast.showSimple('Bank account deleted.')
                    })
                    .catch(() => {
                        this.$mdToast.showSimple('Unable to delete bank account.')
                    })
            })
    }

    getBankAccounts (userId) {
        return this.UsersService.getBankAccounts(userId)
            .then(result => result.map(account => {
                account.type = account.type.toLowerCase()
                return account
            }))
    }

    validatePaymentsTabFlag() {
        this.Auth.splitClient.ready().then(() => {
            this.showPaymentsTab  = this.Auth.splitClient.getTreatment('Payments-tab-flag') === 'on';
        }).catch(() => {
            console.log('Error Initializing Split.io')
        })
    }
}

export default PayrollController
